<template>

  <div class="timeline">
    <div id="gheomtimeline">

    </div>
    <p class="hide">{{earliestLatestInGheomsDate}}</p>
  </div>
</template>

<script>
import vis from 'vis'

export default {
  name: "",
  props: [
    "theproduct", "filCrop"
  ],
  data:function(){ 
    return {
      isLoaded: false,
      items: null,
      options: {
        groupOrder: function(a, b) {
          return a.value - b.value;
        },
        template: function(item) {

          let mytemplate = "<div class='tooltip__wrapper'>"+item.content+"</div>"
          return mytemplate;
        },
        tooltip: {
          followMouse: false
        },
        showTooltips: false,
        stack: false,
        minHeight: "100px",
        timeAxis: {
          scale: "day",
          step: 15
        },
        zoomMin: 1000 * 60 * 60 * 24 * 15,
        zoomMax: 1000 * 60 * 60 * 24 * 31 * 12,
        showMinorLabels: false,
        format: {
          majorLabels: function(date, scale, step) {
            return "<p>"+moment(date).format("MMM") + "<br><span>" + moment(date).format("YYYY")+ "</span></p>"
          } 
        }
      }
    }
  },
  watch: {
    filCrop: function() {
      this.initializeTimeline();
    }
  },
  computed: {
    earliestLatestInGheomsDate: function() {
      let earliestDate = null;
      let latestDate = null;

      this.theproduct.gheoms.forEach((gheom) => {
        gheom.stagedates.forEach((stage) => {
          (moment(stage.control_date).isBefore(earliestDate) || earliestDate == null)? earliestDate = stage.control_date : "";
          (moment(stage.treated_date).isBefore(earliestDate) || earliestDate == null)? earliestDate = stage.treated_date : "";
          (moment(stage.control_date).isAfter(latestDate) || latestDate == null)? latestDate = stage.control_date : "";
          (moment(stage.treated_date).isAfter(latestDate) || latestDate == null)? latestDate = stage.treated_date : "";
        });
      });

      return {"earliest": earliestDate, "latest": latestDate};
    },

    focusYear: function() {
      let latestDate = null;

      this.theproduct.gheoms.forEach((gheom) => {
        gheom.stagedates.forEach((stage) => {
          (moment(stage.control_date).isAfter(latestDate) || latestDate == null)? latestDate = stage.control_date : "";
          (moment(stage.treated_date).isAfter(latestDate) || latestDate == null)? latestDate = stage.treated_date : "";
        });
      });

      return moment(latestDate).format("YYYY");
    },

    gheomsDuration: function() {
      let duration = this.theproduct.gheoms.map((gheom, index) => {
        let earliest = null;
        let latest = null; 
        gheom.stagedates.forEach((stage) => {
          (moment(stage.control_date).isBefore(earliest) || earliest == null)? earliest = stage.control_date : "";
          (moment(stage.treated_date).isBefore(earliest) || earliest == null)? earliest = stage.treated_date : "";
          (moment(stage.control_date).isAfter(latest) || latest == null)? latest = stage.control_date : "";
          (moment(stage.treated_date).isAfter(latest) || latest == null)? latest = stage.treated_date : "";
        })
        let singleDur = "";

        if(moment(latest).diff(earliest, 'months') > 1) {
          singleDur = moment(latest).diff(earliest, 'months')+" months"
        } else {
          if(moment(latest).diff(earliest, 'days') == 0) {
            singleDur = ""
          } else {
            singleDur = moment(latest).diff(earliest, 'days')+" days";
          }
        }
        return singleDur;
      })
      return duration;
    }
  },
  methods: {
    initializeTimeline: function () {
      this.drawChart();
    },

    clickedInTimeline: function () {
      //console.log("clicked");
    },

    onMouseover: function () {
      //console.log("hover");
    },

    showGheom: function (i) {
      this.$emit('showmegheom', i);
    },

    drawChart: function() {
      function bringMyReport(item) {
        if (!item.finished) {
          return "<div class='report-footprint'><div class='report-footprint__chart is--ghost'><div class='rep__row'><span></span><span></span><span></span></div><div class='rep__row'><span></span><span></span><span></span><span></span></div><div class='rep__row'><span></span><span></span><span></span><span></span></div></div></div>"
        } else {
          // Here must be a communication with the server to bring the report
          return "<div class='gheom-loader'><svg width='50' height='25' viewBox='0 0 375 187' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' class='loader--white'><defs ><polygon id='path-1' points='5.63310202e-05 0.0704518744 327.734384 0.0704518744 327.734384 187.428563 5.63310202e-05 187.428563'></polygon></defs> <g  id='Group-3'><path  d='M163.718163,159.981319 L163.718163,160.070824 C169.413845,160.070824 175.109077,160.060189 180.805658,160.073039 C200.064522,160.117792 219.305839,159.792561 238.450421,157.406059 C248.864083,156.107795 259.097323,154.07754 268.915277,150.304156 C286.220989,143.652878 297.726635,131.881212 301.976687,113.79502 C304.606986,102.604692 304.725318,91.3049202 303.119963,79.9621685 C300.284945,59.9374417 289.55858,45.8767541 270.517483,38.0836247 C255.584259,31.9720354 239.792116,29.9107642 223.861845,28.920007 C210.712599,28.1029425 197.52016,27.659849 184.344819,27.617312 C153.034991,27.5171728 121.69097,26.6447216 90.4805772,30.1611121 C79.677724,31.37829 69.057093,33.4470938 58.8814442,37.3396707 C41.5077926,43.986517 29.8248735,55.7502076 25.6243139,73.9436288 C22.5607309,87.2125082 22.5557816,100.584185 25.6378118,113.848634 C29.047392,128.520791 37.4543605,139.612751 51.0017953,146.790424 C57.5015045,150.23459 64.4160505,152.580327 71.5654606,154.284465 C89.8038804,158.632542 108.431941,159.453151 127.0645,159.923273 C139.274739,160.231224 151.499826,159.981319 163.718163,159.981319 M163.745159,187.264361 C151.303205,187.264361 138.855853,187.501416 126.421098,187.211633 C105.226629,186.71847 84.1050491,185.334689 63.4815429,179.945342 C51.0076444,176.685502 39.2432878,171.89832 28.9349092,164.067527 C15.5067062,153.867071 7.50062661,140.272518 3.45799287,124.260446 C-0.176553086,109.866552 -0.61388642,95.2555423 0.623874897,80.5430641 C1.5448845,69.5928932 3.91332346,58.996311 8.57506283,48.9722056 C16.4556115,32.0252066 29.7326376,20.6744792 46.8754743,13.3873626 C58.9777295,8.24304654 71.7080889,5.44579696 84.6989586,3.6091742 C101.934481,1.17260277 119.285636,0.461880716 136.664237,0.301923945 C153.902459,0.143296454 171.146081,-0.066286795 188.380253,0.191593651 C201.475057,0.387884093 214.584709,0.958588585 227.642168,1.94447173 C245.733911,3.31008605 263.557494,6.20880405 280.432621,13.2686136 C306.063864,23.9914775 320.809466,43.1366636 325.526547,69.93762 C328.758404,88.3029614 328.599579,106.658998 324.001729,124.798805 C317.448928,150.653756 300.639041,167.326481 275.556714,176.397492 C263.342426,180.815134 250.679107,183.266771 237.807019,184.797216 C213.19757,187.722963 188.46934,187.587376 163.745159,187.264361' id='Fill-1' fill='#FFFFFF' mask='url(#mask-2)'></path></g> <g id='Group-18' transform='translate(58.571429, 58.571429)' fill='#FFFFFF' class='hide'><path  d='M206.832071,58.2982411 C200.757303,55.361532 194.952152,52.1756347 188.838047,49.6778509 C175.672809,44.2990141 161.825574,42.6866701 147.594689,43.8499696 C129.846855,45.3012478 113.366662,50.9318025 97.2475768,57.7480034 C84.081897,63.315734 70.4357696,67.3891793 56.1456567,69.2043312 C41.7384153,71.034662 27.3974731,70.6362141 13.2054828,67.2803967 C11.1329723,66.7904533 9.63947403,65.8038202 8.29492782,64.3635046 C3.56956835,59.3038478 1.16733013,53.2689422 0.393398373,46.6483814 C-0.344289866,40.334773 -0.131690679,34.0342355 1.781702,27.8795846 C5.01754119,17.472714 12.6976316,11.2164484 22.9121164,7.32641563 C30.9665758,4.25857708 39.4060122,2.75754558 47.9705328,1.91637764 C77.5651353,-0.989551886 107.25786,0.248377467 136.91169,0.337343098 C150.128641,0.376977076 163.366808,1.23079415 176.357016,3.99758312 C182.328799,5.26966516 188.12511,7.00048941 193.519649,9.82715098 C203.90386,15.2679685 209.355857,23.8023446 210.521838,34.8737168 C211.285162,42.1263132 210.874549,49.3181936 207.93352,56.1938455 C207.65639,56.8410599 207.340806,57.4739386 207.015056,58.1004928 C206.925332,58.2733644 206.733064,58.3985909 206.832071,58.2982411' id='Fill-4'></path> <path d='M199.142857,69.8667107 C195.527679,72.6111179 191.353403,74.3903788 186.94686,75.812623 C178.361683,78.5839611 169.366008,79.8195084 160.264004,80.5324501 C137.328365,82.3284519 114.321259,81.9969103 91.3307128,81.9383174 C81.4726413,81.91357 71.6154413,81.4961406 61.7591128,81.2337461 C60.6949536,81.2053594 59.6368951,81.0193904 58.5714286,80.7795596 C76.7545199,78.876562 93.569282,73.449616 110.188382,67.4050783 C120.835639,63.5328475 131.899061,60.7058279 143.446191,59.3214326 C163.189352,56.9547863 181.473979,60.1719404 198.25475,69.217093 C198.545411,69.3735836 198.782472,69.6003129 199.142857,69.8667107' id='Fill-6'></path></g> <circle stroke='#efefef' stroke-width='1' fill='#ffffff' cx='100' cy='92' r='30' class='gheom__circle'></circle></svg></div>"
        }
      }

      function mygroupBy(arr, criteria) {
        var groupBy = function (arr, criteria) {
          return arr.reduce(function (obj, item) {

            // Check if the criteria is a function to run on the item or a property of it
            var key = typeof criteria === 'function' ? criteria(item) : item[criteria];

            // If the key doesn't exist yet, create it
            if (!obj.hasOwnProperty(key)) {
              obj[key] = [];
            }

            // Push the value to the object
            obj[key].push(item);

            // Return the object to the next item in the loop
            return obj;

          }, {});
        };

        let grouped = groupBy(arr, criteria)

        return grouped;
      }

      function buildDotsArray(gheom) {
          let dots = [];
          gheom.stagedates.forEach((stage, stindex) => {
            // Transform array of stages in array of timestamps
            // We will group by date so in the end we will have an array of arrays, in each second-level array all the dots will share the date and the point and the different information will be displayed in the tooltip
            // Array of timestamps should be ordered from the past to the present
            if (stage.control_date == stage.treated_date) {
              let singleDot = {
                "date": stage.control_date,
                "finished": stage.finished,
                "ti": stage.time,
                "which": ""
              }
              dots.push(singleDot);
            } else {
              if(stage.control_date != null){
                let singleDotC = {
                  "date": stage.control_date,
                  "finished": stage.finished,
                  "ti": stage.time,
                  "which": "C"
                };
                dots.push(singleDotC);
              }

              if(stage.treated_date != null) {
              let singleDotT = {
                "date": stage.treated_date,
                "finished": stage.finished,
                "ti": stage.time,
                "which": "T"
              }
              dots.push(singleDotT);
              }
            }
          });

          dots = dots.sort(function(a,b){ return new Date(b.date) - new Date(a.date);});

          dots = dots.reverse();

          let groupedDots = mygroupBy(dots, 'date');

          return Object.keys(groupedDots).map(i => groupedDots[i]);
      }

      function drawTooltip(item, status) {
        let tooltipTemplate = "<div style='width: 0; height: 0;' class='tooltip__inner'><div class='stage__info'><p class='stage'>T"+item.time+status+"</p><p class='date'>"+moment(item.treated_date).format('DDMMM').slice(0, -1)+"</p></div><div class='stage__report'>"+bringMyReport(item)+"</div></div>";
        return tooltipTemplate
      }

      function drawComplexTooltip(item) {
        item = item.sort(function(a,b){ return a.time - b.time;});
        let tooltipTemplate = "";

        item.forEach((myitem) => {
          tooltipTemplate = tooltipTemplate + "<div style='width: 0; height: 0;' class='tooltip__inner tooltip__inner__"+item.length+"'><div class='stage__info'><p class='stage'>T"+myitem.time+"<span>"+myitem.which+"</span></p><p class='date'>"+moment(myitem.date).format("DDMMM")+"</p></div><div class='stage__report'>"+bringMyReport(myitem)+"</div></div>";
        })
        
        return tooltipTemplate
      }

      function getMyYear() {
        let year = moment(newDate()).format("YYYY");
        return year; 
      }

      function gheomType(myGheom) {
        // 0: Standar Gheom. All stages with treated and control dates and in each stage after the previous
        // 1: Mini Gheom. In some stages of the gheom either control or treated is missing, but not both at the same time
        // 2: Null Gheom. In some stages both treated and control are missing 
        // 3: Cutre Gheom. Treated and control date are different and different from null in some stages, maybe the control or treated is shared among stages. Odd Gheoms will be included here
        let codeType = 0;
        const syncTreatedControl = (currentStage) => (currentStage.treated_date == currentStage.control_date && currentStage.treated_date != null && currentStage.control_date != null );
        const asyncTreatedControl = (currentStage) => (currentStage.treated_date != currentStage.control_date && currentStage.treated_date != null && currentStage.control_date != null);
        const nullTreatedOrControl = (currentStage) => ((currentStage.treated_date == null || currentStage.control_date == null) && (currentStage.treated_date != null || currentStage.control_date != null));
        const nullTreatedAndControl = (currentStage) => (currentStage.treated_date == null || currentStage.control_date == null)
        if (myGheom.stagedates.every(syncTreatedControl)) return codeType = 0;
        if (myGheom.stagedates.some(nullTreatedOrControl)) return codeType = 1;
        if (myGheom.stagedates.some(nullTreatedAndControl)) return codeType = 2;
        if (myGheom.stagedates.some(asyncTreatedControl)) return codeType = 3;

        return codeType = 4;
      }

      function isDotLineFinished(dot1, dot2) {
        const unFinished = (dot) => (dot.finished == false);

        if (dot1.some(unFinished) || dot2.some(unFinished)) return "not_finished";
        return ""
      }

      var container = document.getElementById("gheomtimeline");


      let theSet = this.theproduct.gheoms.map((elem, i) => {
        return {
          "content": "<div ref='gheom' data-key='"+i+"' class='timeline__gheom crop--"+elem.crop.logo_name+"'><div class='crop__info'>"+elem.crop.name+"</div><p>"+elem.name+"</p><div class='meta'><p>"+this.gheomsDuration[i]+"</p><ul><li><a class='gheom_navi'><i class='icon-anita-eye'></i></a></li><li><a><i class='icon-anita-download'></i></a></li></ul></div></div>",
          "id": elem.name,
          "value": i + 1,
          "className": "openwheel"
        }
      });


      var groups = new vis.DataSet(theSet);

       const unFinishedDot = (dot) => (dot.finished == false);



      // Creating the timeline
      let timestamps = []
      this.theproduct.gheoms.forEach((gheom, index) => {
        if(this.filCrop != "" && this.filCrop != gheom.crop_id) {
          console.log("no!");
          return 
        }
        let theType = gheomType(gheom);

        const groupedDotsArray = buildDotsArray(gheom);

        groupedDotsArray.forEach((timeDot, dindex) => {

          let complexStage = [];
          timeDot.forEach((singleDot) => {
            let complexStageSingle = {
              "time": singleDot.ti,
              "finished": singleDot.finished,
              "which": singleDot.which,
              "date": singleDot.date
            }
            complexStage.push(complexStageSingle);
          });

          let thefinished = "";
          (timeDot.some(unFinishedDot))? thefinished = "not_finished" : thefinished = ""

          let stampPoint = {
            "id": "gh-"+index+"st-"+"stindex"+"-"+dindex,
            "content": drawComplexTooltip(complexStage),
            "start": timeDot[0].date || new Date(),
            "type": "point",
            "group": gheom.name,
            "className": thefinished
          }

          timestamps.push(stampPoint);

          if(dindex < (groupedDotsArray.length - 1)) {
            let rangefinished = isDotLineFinished(groupedDotsArray[dindex], groupedDotsArray[dindex + 1]);
            let stampLine = {
              "id": "line_"+gheom.name+"_"+"stindex"+"-"+(dindex)+"-"+(dindex + 1)+"",
              "content": "Line between "+dindex+" and "+(dindex + 1)+"",
              "start": groupedDotsArray[dindex][0].date || new Date(),
              "end": groupedDotsArray[dindex + 1][0].date,
              "group": gheom.name,
              "className": rangefinished
            }

            timestamps.push(stampLine);
          }
        });
      })


      this.items = [];

      var timeline = new vis.Timeline(container, this.items, this.options);
      timeline.setItems(new vis.DataSet(timestamps));
      timeline.setGroups(groups);
      timeline.setWindow(''+moment(this.earliestLatestInGheomsDate.latest).format("YYYY")+'-01-01', ''+moment(this.earliestLatestInGheomsDate.latest).format("YYYY")+'-12-31');

      container.addEventListener('mouseover', this.onMouseover);
    }
  },

  mounted: function() {

    let self = this;


    function gheomSelected(i) {
      self.showGheom(i);
    }

    this.initializeTimeline();

    var allGheomsHooks = document.getElementsByClassName("gheom_navi");

    for(let i = 0; i<allGheomsHooks.length;i++) {
        allGheomsHooks[i].onclick = function() {
          gheomSelected(allGheomsHooks[i].closest('.timeline__gheom').getAttribute('data-key'));
        }
    }
    /*document.getElementsByClassName("vis-dot").each((elem) => {
      elem.addEventListener('click', this.clickedInTimeline)
    })*/
  }
}
</script>

<style lang="scss">

  .gheom-loader {
        margin-left: 5px;
  }
  .gheom__circle {
    animation: ghspin 1s infinite;
    position: absolute;
  }

  @keyframes ghspin {
    0% {
      transform: translateX(0)
    }
    50% {
      transform: translateX(125px)
    }
    100% {
      transform: translateX(0)
    }
  }

.vis-timeline,
.vis-foreground .vis-group,
.vis-labelset .vis-label {
  border: none;
}


.vis-labelset .vis-label {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-align-items: center;
	-moz-align-items: center;
  align-items: center;
  	-webkit-justify-content: flex-end;
	-moz-justify-content: flex-end;
	justify-content: flex-end;
}

.vis-time-axis .vis-grid.vis-minor {
  border-color: #AAA9A9;
}

.vis-labelset .vis-label .vis-inner {
  color: #AAA9A9;
  text-align: right;
  padding: 0 0 0.5rem 0;

  //line-height: 80px;
}

.timeline__gheom .meta {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.timeline__gheom ul {
  padding-right: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 0;

  li {
    margin-left: 0.5rem;
  }
}

.timeline__gheom .meta ul {
  padding: 0;
}

.vis-current-time {
  background-color: #DD7814;
}

.timeline__gheom p {
  margin-top: 5px;
  margin-bottom: 0 !important;
  color: #ffffff;
}

.timeline__gheom li a i {
  color: #ffffff;
}

.timeline__gheom li:first-child a i {
  opacity: 0.7;
}

.vis-labelset {
      padding-right: 0rem;
}

.vis-item.vis-box {
  border-radius: 50%;
}

.vis-item.vis-box {
  background-color: #83959c;
  border-color: #83959c;
}

.vis-item {
  background-color: #83959c;
  border-color: #83959c;
    transform: translateY(-26px);
}

.vis-panel.vis-center,
.vis-panel.vis-left,
.vis-panel.vis-bottom {
  border: none;
}

.vis-item.vis-dot {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  transform: translateY(1px);
}

.vis-time-axis .vis-text {
  color: #AAA9A9;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1px;
  padding-left: 0.75rem;
  padding-top: 0.5rem;
}

.vis-time-axis .vis-text p{
      line-height: 0.85rem;
}

.vis-time-axis .vis-text span {
  font-size: 0.6rem;
}

.vis-time-axis {
  overflow: initial;
  top: 20px;
  //transform: translateY(35px);
}

.vis-timeline.vis-bottom {
  overflow: initial;
}

.vis-item .vis-item-overflow {
  height: 5px;
}

.vis-left {
  padding-top: 7px;
}

.vis-label {
  	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-align-items: center;
	-moz-align-items: center;
  align-items: center;
  	-webkit-justify-content: center;
	-moz-justify-content: center;
	justify-content: center;
}

.vis-label .vis-inner {
  height: 80px;
}

.vis-range {
  height: 6px;
}

.vis-group,
.vis-range, 
.vis-dot {
  transition: background-color 0.3s ease;
}

.vis-group:hover {
  .vis-range, .vis-dot {
    background-color: #5199BC;
    border-color: #5199BC;
  }
}

.vis-dot:hover {
  transform: translateY(1px) scale(3);
}

.vis-range.vis-selected {
  border-color: #DD7814;
  background-color: #DD7814;
}

.vis-range.vis-selected:hover {
  border-color: #DD7814;
  background-color: #DD7814;
}

.vis-timeline .vis-point {
  z-index: 10;
}

.vis-item.vis-dot.not_finished,
.vis-item.vis-range.not_finished {
  background: #061B23;
  border-width: 2px;
  border-style: dotted;
}

div.vis-tooltip,
.tooltip__wrapper {
    background-color: #04141b;
    border: none;
    color: #AAA9A9;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    z-index: 11;
    display: flex;
    flex-direction: row;
}

div.vis-tooltip .tooltip__inner,
.tooltip__wrapper .tooltip__inner {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0.5rem;
        padding: 1rem;
    background-color: #04141b;
    border: none;
    color: #AAA9A9;
}

.tooltip__wrapper .tooltip__inner .stage__report {
  border-right: 1px solid #2e2f33;
}

.tooltip__wrapper .tooltip__inner:first-child {
    border-radius: 10px 0 0 10px;
    -webkit-border-radius: 10px 0 0 10px;
}

.tooltip__wrapper .tooltip__inner:last-child {
    border-radius: 0px 10px 10px 0px;
    -webkit-border-radius: 0px 10px 10px 0px;
}

.tooltip__wrapper .tooltip__inner:last-child .stage__report {
  border-right: none;
}

.stage__info {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.stage__info p {
  margin-bottom: 0 !important;
}

.stage__info .stage {
    margin-bottom: 0 !important;
    font-family: Montserrat;
    font-size: 1.5rem;
    font-weight: 600;
    letter-spacing: 1px;
    color: #fff;
    line-height: 1.5rem;
}

.stage__info .stage span {
  font-size: 0.75rem;
}

.stage__info .date {
    margin-bottom: 0 !important;
    text-transform: uppercase;
    font-size: 0.75rem;
}

.tooltip__wrapper {
  padding: 0;
}

.vis-point .tooltip__inner {
  display: none;
}

.vis-point .vis-item-content {
  transform-origin: center bottom;
  transform: translate(20px) rotate(15deg);
  opacity: 0;
}

.vis-point:hover .vis-item-content {
  top: -120px;
  left: -112px;
  width: 180px !important;
  height: 90px !important;
  position: absolute;
  transform-origin: center bottom;
  transform: translate(0) rotate(0deg);
  opacity: 1;
  transition: all 0.3s ease;
}

.vis-point:hover .tooltip__wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
}

.vis-point:hover .tooltip__inner{
  display: grid;
  width: 100% !important;
  height: 100% !important;
}

// MAKE IT BETTER

.vis-panel.vis-center {
  overflow: visible !important;
}

.vis-panel.vis-left {
  background-color: #061B23;
  z-index: 10;
}


.vis-item .vis-dot {
  transition: all 0.3s ease;
}

.vis-item .vis-dot:hover {
  transform: scale(2);
}

.vis-point .tooltip__wrapper {
  position: relative;
}

.vis-panel.vis-center {
  overflow: visible !important;
}

.vis-point .tooltip__wrapper:after {
  position: absolute;
  content: '';
  height: 1rem;
  width: 1rem;
  background: #04141b;
  opacity: 0;
  left: 50%;
  bottom: -0.15rem;
  transform: translateX(-50%) rotate(45deg);
  -webkit-transform: translateX(-50%) rotate(45deg);
  -moz-transform: translateX(-50%) rotate(45deg);
  -o-transform: translateX(-50%) rotate(45deg);
  border-radius: 4px;
  -webkit-border-radius: 4px;
}

.vis-point:hover .tooltip__wrapper:after {
  opacity: 1;
}

.stage__report {
  //border-left: 1px solid #AAA9A9;
  padding: 10px;
  align-items: center;
    display: grid;
}

.single__product.step__grid {
  overflow: hidden;
}

.crop__info {
  font-size: 0.75rem;
}

.vis-label {
  //margin-bottom: 0.5rem;
}

.vis-inner .timeline__gheom {
  padding-right: 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  border-right: 2px solid red;
}


.tooltip__wrapper .tooltip__inner__1 {
  border-radius: 10px !important;
  -webkit-border-radius: 10px !important;
}

.vis-item.vis-point.vis-selected {
  background-color: transparent;
}

.vis-item.vis-selected {
  background-color: #DD7814;
  border-color: #DD7814;
}

.vis-item.vis-selected:hover {
  background-color: #DD7814;
  border-color: #DD7814;  
}
</style>